import React, { useEffect, useRef, useState } from 'react';
import {RouteComponentProps, useHistory} from 'react-router-dom';
import {
    IonButtons,
    IonHeader,
    IonPage,
    useIonViewDidEnter
} from '@ionic/react';
import { StyledIonContent, StyledIonTitle, StyledIonToolbar } from '../../components/content/content.style';
import { StyledHeaderButton, StyledHeaderButtonImage } from '../../components/button/button.style';
import {CheckImage} from "../../utils/styles/icons";
import ArrowLeftImage from '../../assets/images/arrow-left.svg';
import { StyledInput } from '../../components/form/input/input.style';
import { useForm } from 'react-hook-form';
import { StyledContent } from './manualBarcodePage.style';
import Form from '../../components/form';
import StaticPane from '../../components/pane/static-pane.component';
import { useTranslation } from 'react-i18next';
import {findOrderByNumber} from "../../services/report.service";
import {Order} from "./reportPage.component";
import {Links} from "../links";
import {getReportsData, offlineStorageSet} from "../../services/offlineSync.service";
import moment from "moment/moment";
import {findOrderByNumber as findOrderByNumberFactory} from "../../services/reportFactory.service";

interface RouterProps {
    internalCostReport?: string;
}

interface PageProps extends RouteComponentProps<RouterProps> {
}

const ManualOrderFindPage: React.FC<PageProps> = ({match}) => {

    const {params: {internalCostReport}} = match;

    const fieldName = "orderNumber";
    const history = useHistory();
    const { t } = useTranslation();
	const [error, setError] = useState<string>();

    const handleBack = () => {
        history.goBack();
    };

    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);
    const { register, formState: {isValid}, getValues, handleSubmit } = useForm({
        mode: 'all'
    });

    const handleSave = async () => {
        await findOrderByNumberFactory(getValues(fieldName))
            .then(response => {
                history.push(`${Links.report}/${response.id}/0/0/0/0/${internalCostReport}`);
            })
            .catch(reason => {
                let error = reason;
                if (typeof reason === 'object' && reason.message) {
                    error = reason.message
                }

                if (error == 'ORDER_TYPE_NOT_ALLOWED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_type_not_allowed'))
                } else if (error == 'ORDER_NOT_FOUND') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_not_found'))
                } else if (error == 'ORDER_BLOCKED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_blocked'))
                } else if (error == 'ORDER_CLOSED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_closed'))
                } else if (error == 'WORKER_NO_ALLOWED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.worker_no_allowed'))
                } else if (error == 'WORKER_REPORTING_BLOCKED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.worker_reporting_blocked'))
                } else if (error == 'CLIENT_REPORTING_NOT_ENABLE') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.client_reporting_not_enable'))
                } else if (error == 'ORDER_LIMITS_EXCEEDED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_limits_exceeded'))
                } else if (error == 'ORDER_APT_NOT_ALLOWED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_apt_not_allowed'))
                } else if (error == 'ORDER_BLOCKED_BY_STATUS') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.order_blocked_by_status'))
                } else if (error == 'WORKER_NOT_ENABLED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.worker_not_enabled'))
                } else if (error == 'WORKER_WITHOUT_AVAILABILITIES') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.worker_without_availability'))
                } else if (error == 'WORKER_WITHOUT_PROPOSALS') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.worker_without_proposals'))
                } else if (error == 'LOCALIZATION_NOT_AVAILABLE') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.localization_not_available'))
                } else if (error == 'LOCALIZATION_CLIENT_NOT_MATCHING') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.localization_client_not_matching'))
                } else if (error == 'TL_REPORTING_BLOCKED') {
                    setError(t('reportsTab.orders.scanSpecificationPage.error.tl_reporting_blocked'))
                } else {
                    setError(t('reportsTab.orders.manualOrderFind.error.common'))
                }
            });
    };

    useEffect(() => {
        updateHeight();
    });

    useIonViewDidEnter(() => {
        document.getElementsByName(fieldName)[0].focus();
    });

    const updateHeight = () => {
        if (header.current ?.clientHeight == 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current ?.clientHeight);
        }
    };

    const header = useRef<HTMLIonHeaderElement>(null);

	return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <IonButtons slot="start">
                            <StyledHeaderButton onClick={() => handleBack()}>
                                <StyledHeaderButtonImage src={ArrowLeftImage}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                        <StyledIonTitle className="wrap-text">
                            <div className="wrap-text">
                                {t('manualOrderFind.title')}
                            </div>
                        </StyledIonTitle>
                        <IonButtons slot="end">
                            <StyledHeaderButton onClick={() => handleSave()}>
                                <StyledHeaderButtonImage src={CheckImage}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                    </StyledIonToolbar>
                </IonHeader>
                <StaticPane topEdge={topEdge} marginTop={40} hideGrabber={true}>
                    <Form.Container onSubmit={handleSubmit(handleSave)}>
                        <StyledContent>
                            <h3 className="desc">{t("manualOrderFind.number")}</h3>
                            <StyledInput name={fieldName} className={error && 'hasErrors'} inputMode="text" ref={register({
                                required: true
                            })} />
                            {error && <p className="errorMessage">{error}</p>}
                            <Form.Button type="submit" disabled={!isValid}>{t("manualOrderFind.addButton")}</Form.Button>
                        </StyledContent>
                    </Form.Container>
                </StaticPane>
            </StyledIonContent>
        </IonPage>
    );
};

export default ManualOrderFindPage;
